import { render, staticRenderFns } from "./SingleDiscount.vue?vue&type=template&id=0ee89a0c&scoped=true"
import script from "./SingleDiscount.vue?vue&type=script&lang=js"
export * from "./SingleDiscount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee89a0c",
  null
  
)

export default component.exports